import { useEffect } from "react";

/**
 * Redirector page used in transactional/auth emails.
 *
 * Emails link to https://tipomatic.app/auth/redirect?token=...&type=...&redirect_to=...
 * (no supabase host visible to the recipient). This page rebuilds the underlying
 * supabase verify URL and forwards the browser there in the background.
 *
 * Backward compatible: old links of the form /auth/redirect?to=<full supabase url>
 * are still honored.
 */
const SUPABASE_VERIFY_URL = `${import.meta.env.VITE_SUPABASE_URL}/auth/v1/verify`;

const isAllowedRedirect = (urlStr: string) => {
  try {
    const url = new URL(urlStr);
    return (
      url.hostname.endsWith(".supabase.co") ||
      url.hostname === "tipomatic.app" ||
      url.hostname.endsWith(".tipomatic.app") ||
      url.hostname.endsWith(".lovable.app")
    );
  } catch {
    return false;
  }
};

const AuthRedirect = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // Legacy format: ?to=<full encoded supabase url>
    const to = params.get("to");
    if (to) {
      if (isAllowedRedirect(to)) {
        window.location.replace(to);
      } else {
        window.location.replace("/");
      }
      return;
    }

    // New format: forward query params directly to supabase verify endpoint.
    if (params.has("token") || params.has("token_hash")) {
      const target = `${SUPABASE_VERIFY_URL}?${params.toString()}`;
      window.location.replace(target);
      return;
    }

    window.location.replace("/");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Přesměrovávám…
    </div>
  );
};

export default AuthRedirect;
